import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Send } from 'lucide-react';

export const CTASection = ({ onPlanWithUs }) => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-[#FAF9F7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] mb-8 leading-tight">
            {t('ctaTitle')}
          </h2>
          
          <Button 
            onClick={onPlanWithUs}
            size="lg"
            className="bg-[#C4B5A0] hover:bg-[#6B4E37] text-white px-10 py-6 text-lg rounded-md transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
          >
            {t('ctaButton')}
            <Send className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};